export default class AssessmentCancel {

	// constructor
	constructor(selector) {
		this.cancelButtons = document.querySelectorAll('[data-tncp-assessment-cancel-trigger]')

		if(this.cancelButtons.length > 0) {
			this.confirmButton = null
			this.currentAssessmentId = null
			this.currentXhrPath = null

			this.plugin = $.find(selector);

			//Initialize popup element
			$(this.plugin).magnificPopup({
				items: {
					src: '#assessment-cancel-popup',
					type: 'inline'
				}
			});

			this.addEvents()
		}
	};

	initializePopup(assessmentId, xhrPath) {
		this.currentAssessmentId = assessmentId
		this.currentXhrPath = xhrPath

		// Update the xhr path on the confirm button
		this.confirmButton = document.querySelector('[data-tncp-action-assessment-cancel]')
		if(this.confirmButton) {
			this.confirmButton.setAttribute('data-tncp-action-assessment-cancel-xhrpath', xhrPath)
			this.buttonText = this.confirmButton.innerText
			this.buttonSendText = this.confirmButton.getAttribute('data-tncp-action-assessment-cancel-sendingText')
			this.errorText = this.confirmButton.getAttribute('data-tncp-action-assessment-cancel-errorText')
			this.successText = this.confirmButton.getAttribute('data-tncp-action-assessment-cancel-successText')

			// Remove old event listener and add new one
			this.confirmButton.replaceWith(this.confirmButton.cloneNode(true))
			this.confirmButton = document.querySelector('[data-tncp-action-assessment-cancel]')

			// Add click event to confirm button
			this.confirmButton.addEventListener('click', (event) => {
				event.preventDefault()
				this.requestCancelation()
			})
		}

		return this
	}

	closePopup() {
		$.magnificPopup.close()
		return this
	}

	requestCancelation() {
		this.animate(true);

		axios.post(
			this.currentXhrPath,
			'',
			{
				headers : {'Content-Type': 'application/x-www-form-urlencoded'}
			}
		)
			.then((response) => {
				const data = response.data;

				if (data.success) {
					this.closePopup().animate(false).showSuccessInfo()
					// Reload the list by submitting the filter form after 2 seconds
					setTimeout(() => {
						// Close the success popup and overlay
						$.magnificPopup.close();

						// Reload the list
						const filterForm = document.querySelector('[data-tncp-carpoolsassessmentslist="filterForm"]');
						if (filterForm) {
							filterForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
						}
					}, 2000)
				} else {
					// API returned success: false
					this.animate(false).closePopup().showErrorInfo(data.error || this.errorText, data.statusCode)
				}
			})
			.catch((error) => {
				let errorMessage = this.errorText;
				let statusCode = null;

				// Check if error response has a custom error message
				if (error.response) {
					if (error.response.data && error.response.data.error) {
						errorMessage = error.response.data.error;
					}
					if (error.response.data && error.response.data.statusCode) {
						statusCode = error.response.data.statusCode;
					} else if (error.response.status) {
						statusCode = error.response.status;
					}
				}

				this.animate(false).closePopup().showErrorInfo(errorMessage, statusCode)
			});

		return this
	}

	showSuccessInfo() {
		$.magnificPopup.open({
			items: {
				src: "<div class='c-popup'><div class='c-text'><h2>" + this.successText + "</h2></div></div>",
				type: 'inline'
			}
		});

		return this
	}

	showErrorInfo(errorMessage, statusCode) {
		const message = errorMessage || this.errorText;
		let content = "<div class='c-popup'><div class='c-text'><h2>" + message + "</h2>";

		if (statusCode) {
			content += "<p>Fehlercode: " + statusCode + "</p>";
		}

		content += "</div></div>";

		$.magnificPopup.open({
			items: {
				src: content,
				type: 'inline'
			}
		});

		return this
	}

	animate(yes) {
		if(this.confirmButton) {
			if(yes) {
				this.confirmButton.innerText = this.buttonSendText
				this.confirmButton.classList.add('u-skeleton__item', 'u-skeleton__item--full')
			}
			else {
				this.confirmButton.classList.remove('u-skeleton__item','u-skeleton__item--full')
				this.confirmButton.innerText = this.buttonText
			}
		}
		return this
	}

	addEvents() {
		// Add click event to all cancel buttons
		this.cancelButtons.forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault()
				const assessmentId = button.getAttribute('data-tncp-assessment-cancel-id')
				// Get xhrPath from data attribute or href as fallback
				const xhrPath = button.getAttribute('data-tncp-assessment-cancel-xhrpath') || button.getAttribute('href')

				this.initializePopup(assessmentId, xhrPath)

				// Open popup
				$(this.plugin).magnificPopup('open')
			})
		})
	}
}
